/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Credittopupdescription3Inputs */

const en_credittopupdescription3 = /** @type {(inputs: Credittopupdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick how many credits you need.`)
};

const de_credittopupdescription3 = /** @type {(inputs: Credittopupdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl, wie viele Credits du brauchst.`)
};

/**
* | output |
* | --- |
* | "Pick how many credits you need." |
*
* @param {Credittopupdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const credittopupdescription3 = /** @type {((inputs?: Credittopupdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Credittopupdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_credittopupdescription3(inputs)
	return de_credittopupdescription3(inputs)
});
export { credittopupdescription3 as "creditTopUpDescription" }